// File: App.js

import React, {useState} from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { darkTheme, lightTheme } from './themes';
import SkillsSection from './skills';
import ContactSection from './contacts';
import Home from './home';
import Header from './header';
import ProjectsSection from './projects';

function App() {
  const [isLightMode, setIsLightMode] = useState(true); // Set initial state to dark mode

  const handleThemeToggle = () => {
    setIsLightMode((prevMode) => !prevMode);
  };

  return (
    <Router>
      <ThemeProvider theme={isLightMode ?lightTheme : darkTheme}>
        <CssBaseline />
        <div className="app">
        <Header onThemeToggle={handleThemeToggle} isLightMode={isLightMode} />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/projects" element={<ProjectsSection />} />
            <Route path="/Certifications & Skills" element={<SkillsSection />} />
            <Route path="/Contacts" element={<ContactSection />} />
          </Routes>
        </div>
      </ThemeProvider>
    </Router>
  );
}

export default App;
